module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ../~/axios/index.js
// module id = 510
// module chunks = 0